"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _VerticalNavigationContainer = _interopRequireDefault(require("./vertical/VerticalNavigationContainer"));

var _HorizontalNavigationContainer = _interopRequireDefault(require("./horizontal/HorizontalNavigationContainer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NavigationContainer = function NavigationContainer(_ref) {
  var children = _ref.children,
      loggedIn = _ref.loggedIn,
      displayEnvIndicator = _ref.displayEnvIndicator,
      vertical = _ref.vertical;
  return _react["default"].createElement(_react["default"].Fragment, null, vertical ? _react["default"].createElement(_VerticalNavigationContainer["default"], {
    loggedIn: loggedIn,
    displayEnvIndicator: displayEnvIndicator
  }, children) : _react["default"].createElement(_HorizontalNavigationContainer["default"], {
    loggedIn: loggedIn,
    displayEnvIndicator: displayEnvIndicator
  }, children));
};

NavigationContainer.defaultProps = {};
NavigationContainer.propTypes = {
  /** if the navigation is vertical */
  vertical: _propTypes["default"].bool.isRequired,

  /** if the user is logged in */
  loggedIn: _propTypes["default"].bool.isRequired,

  /** if the env indicator is displayed */
  displayEnvIndicator: _propTypes["default"].bool.isRequired,

  /** children to pass to container */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = NavigationContainer;
exports["default"] = _default;